// Generated by purs version 0.13.8
"use strict";
var Color = require("../Color/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Lunarbox_Capability_Editor_Type = require("../Lunarbox.Capability.Editor.Type/index.js");
var Lunarbox_Component_HighlightedText = require("../Lunarbox.Component.HighlightedText/index.js");
var Lunarbox_Data_Char = require("../Lunarbox.Data.Char/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var Lunarbox_Math_SeededRandom = require("../Lunarbox.Math.SeededRandom/index.js");
var highlightedType = function (container) {
    return function (bold) {
        return function (highlight) {
            var $$continue = function (type$prime) {
                return highlightedType(container)(bold)(highlight)(type$prime);
            };
            return function (v) {
                if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v.value0 === "Function" && v.value1.length === 2)) {
                    var result = $$continue(v["value1"][0]);
                    var isArrow = (function () {
                        if (v["value1"][0] instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v["value1"][0].value0 === "Function" && v["value1"][0].value1.length === 2)) {
                            return true;
                        };
                        return false;
                    })();
                    return container([ (function () {
                        if (isArrow) {
                            return container([ Halogen_HTML_Core.text("("), result, Halogen_HTML_Core.text(")") ]);
                        };
                        return result;
                    })(), bold(Halogen_HTML_Core.text(Lunarbox_Data_String.spaced(Lunarbox_Data_Char.arrow))), $$continue(v["value1"][1]) ]);
                };
                if (v instanceof Lunarbox_Data_Dataflow_Type.TConstant && (v.value0 === "Array" && v.value1.length === 1)) {
                    return container([ bold(Halogen_HTML_Core.text("[")), $$continue(v["value1"][0]), bold(Halogen_HTML_Core.text("]")) ]);
                };
                if (v instanceof Lunarbox_Data_Dataflow_Type.TVariable) {
                    var shade = Lunarbox_Math_SeededRandom.seededInt(Data_Show.show(Lunarbox_Data_Dataflow_Type.tvarShow)(v.value1))(100)(255);
                    return highlight(Color.rgb(shade)(shade)(shade))(Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Data_Dataflow_Type.tvarShow)(v.value1)));
                };
                var color = Lunarbox_Capability_Editor_Type.typeToColor(v);
                return highlight(color)(Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Data_Dataflow_Type.typeShow)(v)));
            };
        };
    };
};
var highlightTypeToHTML = highlightedType(Halogen_HTML_Elements.span_)(Lunarbox_Component_HighlightedText.bold)(Lunarbox_Component_HighlightedText.highlight);
module.exports = {
    highlightedType: highlightedType,
    highlightTypeToHTML: highlightTypeToHTML
};
